import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'

import { BlogComment } from '@/models/Posts'
import fetchBlogComments from '@/utils/api/fetchBlogComments'
import { fixNextPageUrl } from '@/utils/helper'

const useBlogComments = (id?: number) => {
  const [comments, setcomments] = useState<BlogComment[]>([])
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [loadingNext, setLoadingNext] = useState(false)
  const [error, setError] = useState('')

  const { locale } = useRouter()

  //To fetch the new comment without refresh, remove the last comment if nextPageURL is present and insert new comment at first position
  const fetchNewComment = useCallback(
    async (newComment: BlogComment) => {
      if (comments) {
        setLoadingNext(true)
        if (nextPageUrl) comments.pop()
        comments.unshift(newComment)
        setLoadingNext(false)
      }
    },
    [comments, nextPageUrl]
  )

  const fetchNext = useCallback(async () => {
    if (nextPageUrl) {
      setLoadingNext(true)
      const response = await fetchBlogComments(nextPageUrl)
      if (response) {
        const { results, next } = response
        setcomments((prev) => prev.concat(...results))
        setNextPageUrl(fixNextPageUrl(next) as string | null)
        setError('')
      } else {
        //TODO:: handle rejection
        setError('unable_to_fetch_more_data_caption')
      }
      setLoadingNext(false)
    }
  }, [nextPageUrl])

  const getComments = useCallback(async () => {
    setLoading(true)
    const url = `blog/v1/post/${id}/comments`
    const response = await fetchBlogComments(url, {
      lang: locale,
      page: 1,
      page_size: 2,
    })
    if (response) {
      const { results, next } = response
      setcomments(results)
      setNextPageUrl(fixNextPageUrl(next) || null)
      setError('')
    } else {
      //TODO:: Handle rejection
      setError('unable_to_fetch_data_caption')
    }
    setLoading(false)
  }, [locale, id])

  useEffect(() => {
    if (id) getComments()
  }, [id, getComments])

  return {
    fetchNext,
    loading,
    loadingNext,
    comments,
    nextPageUrl,
    error,
    getComments,
    fetchNewComment,
  }
}

export default useBlogComments
